import { BaseModel } from '@tcc-mono/shared/data-access';
import { TransportGroup } from './transport-group.model';
import { BookingItem } from './booking-item.model';

export class SalesInvoice extends BaseModel {
  id: number;
  delivery_address: string;
  delivery_address_zip: string;
  delivery_address_city: string;
  delivery_address_country: string;
  delivery_date: string;
  invoice_date: string;
  relation_id: number;
  relation_name?: string;
  lines: SalesInvoiceLine[];
  animal_count?: number;

  created_at?: string;
  exact_exported_at?: string;
  invoice_number?: string;
  sum?: string;
  net_sum?: string;
  updated_at?: string;
  relation_exact_code?: string;
  relation_email?: string;

  destination_stables_summary?: string;

  payed?: boolean;
}

export class SalesInvoiceLine {
  id?: number;
  sales_invoice_id: number;
  delivery_date: string;
  description?: string;
  pcs: number;
  unit_price: number;
  sum: number;
  avg_weight: number;
  transport_group_ids: number[];
  transport_groups: TransportGroup[];
  booking_item_id: number;
  vat_percentage: number;
}
